// GestionInventarioCuadre.actions.ts
import { queryClient } from '@/shared/query-client/query-client';
import { useMutation, useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { UseFetchEnabledParams, UseMutationsParams, UseUpdateParams } from "@/shared/interfaces";
//import { urlBackend } from "@/shared/constants";
import { erpApi } from "@/shared/axios";
import { getUrlParamsFetch } from "@/shared/utils";
import { toApiError } from "@/shared/utils/general";
import { GestionInventarioCuadre, GestionInventarioCuadreEstadistica, GestionInventarioCuadreForm, GestionInventarioCuadrePagingResp, GestionInventarioCuadreParams, PayloadEgresoGestionInventarioCuadreArray } from '@/erp/contabilidad/gestion-inventario-cuadre';
import { urlBackend } from '@/shared/constants';

const { get, post, put } = erpApi();

//const urlBackend = 'http://localhost:8093/'; // TODO: solo para pruebas

// get

export const useFetchGetGestionInventarioCuadre = ({
  enabled = true,
  params,
}: UseFetchEnabledParams<GestionInventarioCuadreParams> = {}) => {
  return useQuery({
    queryKey: ['gestion-equipo-cuadre', ...Object.values(params ?? {})],
    queryFn: () => getGestionInventarioCuadre(params),
    enabled: enabled,
    refetchOnWindowFocus: false,
  });
};

export const getGestionInventarioCuadre = async (
  params?: GestionInventarioCuadreParams
) => {
  const queryParams = getUrlParamsFetch(params ?? {});

  console.log(queryParams);
  
  return get<GestionInventarioCuadrePagingResp>(`${urlBackend}api/v1/contabilidad/gestion-equipo-cuadre?${queryParams}`, true);
};

// create

export const useFetchPostGestionInventarioCuadre = ({
  returnUrl,
  navigate
}: UseMutationsParams = {}) => {

  return useMutation({
    mutationFn: (data: GestionInventarioCuadreForm) => {
      return postGestionInventarioCuadre(data)
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: ['gestion-equipo-cuadre']
      });

      navigate && returnUrl && navigate(returnUrl);

      toast.success(data.message);

    },
    onError: ((error) => {
      const data = toApiError(error)
      toast.error(data.message)
    }),
    onSettled: () => {

    },
  });
};

export const postGestionInventarioCuadre = async (data: GestionInventarioCuadreForm) => {
  return await post<GestionInventarioCuadre>(`${urlBackend}api/v1/contabilidad/gestion-equipo-cuadre/`, data, true);
};

// filter by id

export const useFetchGetByIdGestionInventarioCuadre = (id: string) => {
  return useQuery({
    queryKey: ['gestion-equipo-cuadre', id],
    queryFn: async () => {
      return getByIdGestionInventarioCuadre(id);
    },
    refetchOnWindowFocus: false,
  });
};

export const getByIdGestionInventarioCuadre = async (id: string) => {
  const res = await get<GestionInventarioCuadre>(`${urlBackend}api/v1/contabilidad/gestion-equipo-cuadre/${id}`, true);
  return res;
};

// update

export const useFetchPutGestionInventarioCuadre = ({
  navigate,
  returnUrl
}: UseMutationsParams = {}) => {

  return useMutation({
    mutationFn: (data: UseUpdateParams<GestionInventarioCuadreForm>) => {
      return putGestionInventarioCuadre(data);
    },
    onSuccess: (res) => {
      queryClient.invalidateQueries({
        queryKey: ['gestion-equipo-cuadre']
      });

      navigate && returnUrl && navigate(returnUrl);

      toast.success(res.message);
    },
    onError: (error) => {
      const data = toApiError(error)
      toast.error(data.message)
    },
    onSettled: () => {

    },
  });
};

export const putGestionInventarioCuadre = async ({
  id,
  data
}: UseUpdateParams<GestionInventarioCuadreForm>) => {
  return put<GestionInventarioCuadre>(`${urlBackend}api/v1/contabilidad/gestion-equipo-cuadre/${id}`, data, true);
};


// egreso gestion inventario

export const useFetchPostEgresoGestionInventarioCuadre = ({
  returnUrl,
  navigate
}: UseMutationsParams = {}) => {

  return useMutation({
    mutationFn: (data: PayloadEgresoGestionInventarioCuadreArray) => {
      return postEgresoGestionInventarioCuadre(data)
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: ['gestion-equipo-cuadre']
      });

      navigate && returnUrl && navigate(returnUrl);

      toast.success(data.message);

    },
    onError: ((error) => {
      const data = toApiError(error)
      toast.error(data.message)
    }),
    onSettled: () => {

    },
  });
};

export const postEgresoGestionInventarioCuadre = async (data: PayloadEgresoGestionInventarioCuadreArray) => {
  return await post<GestionInventarioCuadre>(`${urlBackend}api/v1/egreso-inventario/gestion-contabilidad/`, data, true);
};


export const useFetchGetGestionInventarioCuadreEstadistica = ({
  enabled = true,
  params,
}: UseFetchEnabledParams<{ estado: string; tipoGestion: string }> = {}) => {
  return useQuery({
    queryKey: ['gestion-equipo-cuadre', ...Object.values(params ?? {})],
    queryFn: () => getGestionInventarioCuadreEstadistica(params),
    enabled: enabled,
    refetchOnWindowFocus: false,
  });
};

export const getGestionInventarioCuadreEstadistica = async (
  params?: { estado: string; tipoGestion: string }
) => {
  const queryParams = getUrlParamsFetch(params ?? {});
  
  return get<GestionInventarioCuadreEstadistica>(`${urlBackend}api/v1/contabilidad/gestion-equipo-cuadre/totales-tipo-gestion?${queryParams}`, true);
};
